import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ApiService } from '../../../../services/api.service';
import { AnagraficaRubrica, ConfigurazioneAccreditamenti, DocumentoAccredito, Evento, Persona, Spettacolo, Subappalto } from '../../../../shared/interface';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { RadioButtonClickEvent } from 'primeng/radiobutton';
import { Subscription } from 'rxjs';

type CollectingDirittiAutore = { nome: string; percentuale: number | string };

@Component({
  selector: 'app-accredito-backoffice',
  templateUrl: './accredito-backoffice.component.html',
  styleUrl: './accredito-backoffice.component.css'
})
export class AccreditoBackofficeComponent implements OnInit, OnDestroy {

  constructor (private apiService: ApiService, private confirmationService: ConfirmationService, private router: Router, private route: ActivatedRoute, private datePipe: DatePipe, private cdr: ChangeDetectorRef) {}

  @Input() evento?: Evento;
  @Input() spettacolo?: Spettacolo;
  @Output() noteChanged = new EventEmitter<void>();

  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;  

  documenti: DocumentoAccredito[] = [];
  agibilita_inps: DocumentoAccredito[] = [];
  schede_tecniche: DocumentoAccredito[] = [];
  montaggio: DocumentoAccredito[] = [];

  private sub = new Subscription();

  openSections: Record<string, boolean> = {
    segnalazioni: true,
    dossier: true,
    info: false,
    personale: false,
    subappalti: false,
    impianti: false,
    diritti: false,
    mezzi: false,
  };

  impiantiOptions = [
    { id: 'impianto1', value: 'impianti_elettrici', label: 'Impianti Elettrici', control: 'impianti_elettrici_file' },
    { id: 'impianto_luci', value: 'impianti_luci', label: 'Impianti Luci', control: 'impianti_luci_file' },
    { id: 'impianto2', value: 'impianti_audio', label: 'Impianti Audio', control: 'impianti_audio_file' },
    { id: 'impianto3', value: 'impianti_video', label: 'Impianti Video', control: 'impianti_video_file' },
    { id: 'impianto4', value: 'effetti_scenici', label: 'Effetti Scenici', control: 'effetti_scenici_file' },
    { id: 'impianto5', value: 'macchina_fumo', label: 'Macchina del fumo', control: 'macchina_fumo_file' },
    { id: 'impianto6', value: 'carichi_sospesi', label: 'Carichi Sospesi', control: 'carichi_sospesi_file' },
  ];

  pos: boolean = false;
  attivita_rischio: boolean = true;
  certificazioni_impianti: boolean = false;  
  certificazione_impianti: boolean = true;  
  
  loading: boolean = false;
  configurazione?: ConfigurazioneAccreditamenti;

  rubricaCompagnie: AnagraficaRubrica[] = [];
  rubricaCompagniaSel: AnagraficaRubrica | null = null;

  noteEvento: { id: number; sezione: string; testo: string; autore?: string; created_at: string; inviata_at?: string | null }[] = [];
  notaDraft = '';
  invioNoteLoading = false;

  /** Stable Date for p-calendar — never recreate in a getter (infinite CD/crash). */
  visuraScadenzaModel: Date | null = null;
  /** Stable empty array for @Input bindings (avoid `|| []` new ref every CD). */
  readonly emptyList: never[] = [];

  formEvento!: FormGroup;

  ngOnInit(): void {

    this.formEvento = new FormGroup({
      evento: new FormControl(null, Validators.required),
      dal_al: new FormControl(null, Validators.required),            
      blocco: new FormControl(null, Validators.required),            
      durata: new FormControl(null, Validators.required),
      intervallo: new FormControl(null, Validators.required),
      foto: new FormControl(null, Validators.required),
      merchandising: new FormControl(null, Validators.required),
      merchandising_ditta: new FormControl(null),
      merchandising_visura: new FormControl(null),
      merchandising_fatturazione: new FormControl(null),
      merchandising_email: new FormControl(null),      
      firmacopie: new FormControl(null, Validators.required),
      firmacopie_email: new FormControl(null),
      collecting: new FormArray([]),
      ragione_sociale: new FormControl(null, Validators.required),
      piva: new FormControl(null, Validators.required),
      sede: new FormControl(null, Validators.required),      
      anagrafica: new FormControl(null, Validators.required),      
      email: new FormControl(null, [Validators.required, Validators.email]),
      telefono: new FormControl(null, [Validators.required, Validators.pattern('^(?=[0-9]*$)(?:.{9}|.{10})$')]),      
      // BO: file opzionali; obblighi solo lato compagnia via flag sotto
      visura_camerale: new FormControl(null),      
      duvri_file: new FormControl(null),
      obbl_visura_compagnia: new FormControl(false),
      obbl_pos_compagnia: new FormControl(false),
      obbl_visura_subappalti: new FormControl(false),
      obbl_pos_subappalti: new FormControl(false),
      agibilita_inps_file: new FormControl(null),
      scheda_tecnica: new FormControl(null),
      pass_compagnia: new FormControl(null),
      pass_compagnia_file: new FormControl(null),
      attivita: new FormControl(null, Validators.required),      
      montaggio: new FormControl(null),
      montaggio_file: new FormControl(null),
      certificazione_impianti: new FormControl(null, Validators.required),
      impianti_elettrici_file: new FormControl(null),
      impianti_luci_file: new FormControl(null),
      impianti_audio_file: new FormControl(null),
      impianti_video_file: new FormControl(null),
      effetti_scenici_file: new FormControl(null),
      macchina_fumo_file: new FormControl(null),
      carichi_sospesi_file: new FormControl(null),            
      certificazione_impianti_extra: new FormControl(null),            
      certificazione_impianti_extra_file: new FormControl(null),             
    })

    this.getEvento();
    this.loadRubricaCompagnie();
  }

  private loadRubricaCompagnie() {
    this.apiService.getRubrica().subscribe({
      next: (list) => {
        this.rubricaCompagnie = (list || [])
          .slice()
          .sort((a, b) => (a.ragione_sociale || '').localeCompare(b.ragione_sociale || '', 'it'));
      },
      error: () => { this.rubricaCompagnie = []; },
    });
  }

  onRubricaCompagnia(sel: AnagraficaRubrica | null) {
    this.rubricaCompagniaSel = sel;
    if (!sel) return;
    // Solo anagrafica compagnia: non sovrascrivere il referente già inserito dalla compagnia
    const empty = (v: unknown) => !String(v ?? '').trim();
    const cur = this.formEvento.getRawValue();
    this.formEvento.patchValue({
      ragione_sociale: sel.ragione_sociale || '',
      piva: sel.piva || '',
      sede: sel.sede || '',
      ...(empty(cur.anagrafica) && sel.referente ? { anagrafica: sel.referente } : {}),
      ...(empty(cur.email) && sel.email ? { email: sel.email } : {}),
      ...(empty(cur.telefono) && sel.telefono ? { telefono: sel.telefono } : {}),
    });
    if (!this.evento?.id || !sel.id) return;
    this.apiService.applicaDocumentiRubricaEvento(sel.id, this.evento.id).subscribe({
      next: (res) => {
        if (!res?.applied || !this.evento) return;
        if (res.visura_camerale) this.evento.visura_camerale = res.visura_camerale;
        if (res.duvri) this.evento.duvri = res.duvri;
        this.apiService.setDocumentiEvento(this.evento.id);
        this.cdr.markForCheck();
      },
      error: () => {},
    });
  }

  toggleSec(key: string) {
    this.openSections[key] = !this.openSections[key];
  }

  /** Come portale: giallo se vuoto non obbligatorio; rosso se manca obbligatorio. */
  secStato(sec: string): { cls: string; text: string } {
    const level = this.secLevel(sec);
    // empty = modulo opzionale senza dati → giallo
    if (level === 'empty') return { cls: 'warn', text: 'Nessun dato inserito' };
    const text = level === 'ok' ? 'Dati compilati' : level === 'crit' ? 'Dati assenti' : 'Dati incompleti';
    return { cls: level, text };
  }

  /** Chip extra (es. agibilità: compilati + da accettare) */
  secChips(sec: string): { cls: string; text: string }[] {
    const chips = [this.secStato(sec)];
    if (sec === 'impianti' && this.secLevel('impianti') === 'ok' && this.impiantiDaAccettare()) {
      chips.push({ cls: 'wait', text: 'Dati da accettare' });
    }
    return chips;
  }

  private impiantiDaAccettare(): boolean {
    const all = [...this.agibilita_inps, ...this.montaggio, ...this.documenti];
    return all.some(d => !!d.file && (d.stato === 'ok' || !d.stato));
  }

  private countTipoDocs(tipo: string): number {
    const saved = (this.evento?.documenti || []).filter(d => d.tipo === tipo).length;
    const pending = this.formEvento?.get(`${tipo}_file`)?.value;
    const pendingLen = Array.isArray(pending) ? pending.length : pending ? 1 : 0;
    return saved + pendingLen;
  }

  /** File pass: colonna evento oppure documento in elenco (recupero se colonna azzerata). */
  get passCompagniaFile(): string {
    const fromEvent = String(this.evento?.pass || '').trim();
    if (fromEvent) return fromEvent;
    const doc = (this.evento?.documenti || []).find(d => d.tipo === 'pass_compagnia' && d.file);
    return String(doc?.file || '').trim();
  }

  private syncPassFromDocumenti() {
    if (!this.evento || String(this.evento.pass || '').trim()) return;
    const doc = (this.evento.documenti || []).find(d => d.tipo === 'pass_compagnia' && d.file);
    if (doc?.file) this.evento.pass = doc.file;
  }

  private personaHasDoc(p: Persona, ...tipi: string[]): boolean {
    return (p.documenti || []).some(d => tipi.includes(d.tipo) && !!(d.file && String(d.file).trim()));
  }

  /** Alert/chip: UniLav/certificazioni mancanti → warn (senza bloccare il save BO). */
  private unilavRequired(p: Persona): boolean {
    const cat = (p.categoria || '').toLowerCase();
    if (cat.includes('produzione') && cat.includes('organizzazione')) return false;
    const ruolo = (p.ruolo || '').toLowerCase().trim();
    if (['direzione di produzione', 'tour manager', 'assistente di produzione', 'altro ruolo organizzativo'].includes(ruolo)) return false;
    const inps = (p as any).inps;
    if (Array.isArray(inps) ? inps.length > 0 : !!(inps && String(inps).trim())) return false;
    if (this.personaHasDoc(p, 'inps')) return false;
    return true;
  }

  private personaDocsOk(p: Persona): boolean {
    if (this.unilavRequired(p) && !this.personaHasDoc(p, 'unilav')) return false;
    if ((p.ruolo || '').toLowerCase().trim() === 'rigger / lavori in quota') {
      if (!this.personaHasDoc(p, 'certificazione', 'certificazioni')) return false;
    }
    return true;
  }

  private flagOn(name: string): boolean {
    return !!this.formEvento?.get(name)?.value;
  }

  get visuraCompagniaObbl(): boolean {
    return this.flagOn('obbl_visura_compagnia') || !!(this.evento as any)?.obbl_visura_compagnia;
  }

  get posCompagniaObbl(): boolean {
    return this.flagOn('obbl_pos_compagnia') || !!(this.evento as any)?.obbl_pos_compagnia;
  }

  get visuraSubappaltiObbl(): boolean {
    return this.flagOn('obbl_visura_subappalti') || !!(this.evento as any)?.obbl_visura_subappalti;
  }

  get posSubappaltiObbl(): boolean {
    return this.flagOn('obbl_pos_subappalti') || !!(this.evento as any)?.obbl_pos_subappalti;
  }

  /** @deprecated usare i flag split; tenuto per template legacy */
  get docsObbligatori(): boolean {
    return this.visuraCompagniaObbl || this.posCompagniaObbl;
  }

  get hasMontaggio(): boolean {
    const v = this.formEvento?.get('montaggio')?.value;
    return Array.isArray(v) ? v.includes('montaggio') : !!v;
  }

  private subappaltoDocsOk(s: Subappalto): boolean {
    if (this.visuraSubappaltiObbl && !(s.visura_camerale && String(s.visura_camerale).trim())) return false;
    if (this.posSubappaltiObbl && !(s.pos && String(s.pos).trim())) return false;
    return true;
  }

  private siNoFromDb(dbValue: boolean | number | null | undefined): 'Si' | 'No' | null {
    if (dbValue === true || dbValue === 1) return 'Si';
    if (dbValue === false || dbValue === 0) return 'No';
    return null;
  }

  impiantiDeciso(): boolean {
    return Array.isArray(this.formEvento?.get('certificazione_impianti')?.value);
  }

  hasImpiantoNo(value: string): boolean {
    return this.impiantiDeciso() && !this.hasImpianto(value);
  }

  private secLevel(sec: string): string {
    const f = this.formEvento;
    if (!f) return 'crit';
    switch (sec) {
      case 'dossier': {
        const fields = ['evento', 'dal_al', 'ragione_sociale', 'piva', 'sede', 'anagrafica', 'email', 'telefono'];
        const filled = fields.filter(n => !!f.get(n)?.value).length;
        const hasVisura = !!(this.evento?.visura_camerale || f.get('visura_camerale')?.value);
        const hasPos = !!(this.evento?.duvri || f.get('duvri_file')?.value);
        const docsObblMancanti =
          (this.visuraCompagniaObbl && !hasVisura) || (this.posCompagniaObbl && !hasPos);
        // Campi anagrafici obbligatori assenti, o doc obbligatori mancanti → rosso
        if (!filled) return 'crit';
        if (docsObblMancanti) return 'crit';
        if (filled === fields.length) return 'ok';
        return 'warn';
      }
      case 'info': {
        // Campi info obbligatori / condizionalmente obbligatori → rosso se assenti
        if (['durata', 'intervallo', 'foto', 'merchandising', 'firmacopie', 'blocco'].some(n => f.get(n)?.invalid)) return 'crit';
        if (f.get('merchandising')?.value === 'Si' && !(f.get('merchandising_ditta')?.value && (this.evento?.merchandising_visura || f.get('merchandising_visura')?.value))) return 'crit';
        if (f.get('firmacopie')?.value === 'Si' && f.get('firmacopie_email')?.invalid) return 'crit';
        return 'ok';
      }
      case 'personale': {
        const personale = this.evento?.personale || [];
        // Elenco vuoto: non obbligatorio in BO → giallo
        if (!personale.length) return 'empty';
        // Pass / UniLav / cert richiesti ma mancanti → rosso
        if (f.get('pass_compagnia')?.value === 'Si' && !(this.passCompagniaFile || f.get('pass_compagnia_file')?.value)) return 'crit';
        if (!personale.every(p => this.personaDocsOk(p))) return 'crit';
        return 'ok';
      }
      case 'subappalti': {
        const subs = this.evento?.subappalti || [];
        // Nessun subappalto: modulo opzionale → giallo
        if (!subs.length) return 'empty';
        // Visura/POS obbligatori (flag) ma mancanti → rosso
        return subs.every(s => this.subappaltoDocsOk(s)) ? 'ok' : 'crit';
      }
      case 'impianti': {
        const impianti: string[] = f.get('certificazione_impianti')?.value || [];
        const attivitaOk = !f.get('attivita')?.invalid && !!f.get('attivita')?.value;
        // Matrice / attività non decise → obbligatorio → rosso
        if (!impianti.length || f.get('certificazione_impianti')?.invalid || !attivitaOk) {
          return 'crit';
        }
        // Si/No "nessun impianto" → risposta data
        if (impianti.includes('non_presenti')) return 'ok';
        // Impianto dichiarato Si senza file → obbligatorio → rosso
        for (const v of impianti) {
          if (v === 'altro') {
            if (!f.get('certificazione_impianti_extra')?.value) return 'crit';
            if (this.countTipoDocs('certificazione_impianti_extra') < 1) return 'crit';
          } else if (this.countTipoDocs(v) < 1) {
            return 'crit';
          }
        }
        return 'ok';
      }
      case 'diritti': {
        // Collecting opzionale: vuoto → giallo; righe incomplete → giallo (incompleto)
        if (!this.collectingArray.length) return 'empty';
        return this.collectingArray.controls.every(g => g.valid) ? 'ok' : 'warn';
      }
      case 'mezzi':
        // Mezzi opzionali: vuoto → giallo
        return (this.evento?.mezzi || []).length ? 'ok' : 'empty';
      default:
        return 'warn';
    }
  }

  getEvento() {    

    const ev = this.evento as any;
    // Fallback: vecchio flag unico → tutti e quattro
    const legacy = !!ev?.obbligatorieta;
    this.formEvento.patchValue({
      evento: this.evento?.evento,
      dal_al: [new Date(this.evento!.dal), new Date(this.evento!.al)],
      obbl_visura_compagnia: ev?.obbl_visura_compagnia != null ? !!ev.obbl_visura_compagnia : legacy,
      obbl_pos_compagnia: ev?.obbl_pos_compagnia != null ? !!ev.obbl_pos_compagnia : legacy,
      obbl_visura_subappalti: ev?.obbl_visura_subappalti != null ? !!ev.obbl_visura_subappalti : legacy,
      obbl_pos_subappalti: ev?.obbl_pos_subappalti != null ? !!ev.obbl_pos_subappalti : legacy,
      blocco: this.evento?.blocco ? this.evento?.blocco : null,
      attivita: this.evento?.attivita ? this.evento?.attivita.split(',') : null,
      durata: (this.evento?.durata || 0) > 0 ? this.evento?.durata : null,
      intervallo: this.siNoFromDb(this.evento?.intervallo as any),
      foto: this.siNoFromDb(this.evento?.foto as any),
      merchandising: this.siNoFromDb(this.evento?.merchandising as any),
      merchandising_ditta: this.evento?.merchandising_ditta,
      merchandising_visura: this.evento?.merchandising_visura,
      merchandising_fatturazione: this.evento?.merchandising_fatturazione,
      merchandising_email: this.evento?.merchandising_email,
      firmacopie: this.siNoFromDb(this.evento?.firmacopie as any),
      firmacopie_email: this.evento?.firmacopie_email,
      montaggio: this.evento?.montaggio ? ['montaggio'] : null,
      certificazione_impianti: (this.evento?.certificazione_impianti || '').length > 0 ? this.evento?.certificazione_impianti.split(',') : null,
      certificazione_impianti_extra: this.evento?.certificazione_impianti_extra,
      ragione_sociale: this.evento?.ragione_sociale,
      piva: this.evento?.piva,
      sede: this.evento?.sede,
      anagrafica: this.evento?.anagrafica,
      email: this.evento?.email,
      telefono: this.evento?.telefono,
      visura_camerale: this.evento?.visura_camerale,
      duvri: this.evento?.duvri,
      pass_compagnia: this.siNoFromDb(this.evento?.check_pass as any),
      pass_compagnia_file: this.evento?.pass,
    });

    this.setCollecting(this.parseCollecting(this.evento?.collecting));
    const merch = this.siNoFromDb(this.evento?.merchandising as any);
    if (merch) this.onMerchandising({ value: merch } as RadioButtonClickEvent);
    const firma = this.siNoFromDb(this.evento?.firmacopie as any);
    if (firma) this.onFirmacopie({ value: firma } as RadioButtonClickEvent);

    this.syncPassFromDocumenti();
    this.documenti = [...this.evento?.documenti || []].filter(documento =>  !documento.id_personale && (documento.tipo != 'inps' && documento.tipo != 'scheda_tecnica' && documento.tipo != 'montaggio' && documento.tipo != 'pass_compagnia'));
    this.agibilita_inps = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'inps');
    this.schede_tecniche = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'scheda_tecnica');
    this.montaggio = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'montaggio');
    
    this.getData();    
    this.onCertificazioni();
    this.loadNote();
    this.apiService.getConfigurazioneAccreditamenti().subscribe({
      next: (c) => this.configurazione = c,
      error: () => {},
    });

    this.loading = false;     
    this.cdr.detectChanges();           
  }

  onDocumento(file: string) {
    this.apiService.openProtectedFile(file);
  }

  loadNote() {
    if (!this.evento?.id) return;
    this.apiService.getNoteEvento(this.evento.id).subscribe({
      next: (data) => {
        this.noteEvento = data || [];
        const pending = this.notePending;
        this.notaDraft = pending?.testo || '';
      },
      error: () => {
        this.noteEvento = [];
        this.notaDraft = '';
      },
    });
  }

  get notePending() {
    return this.noteEvento.find(n => !n.inviata_at) || null;
  }

  get noteInviate() {
    return this.noteEvento.filter(n => !!n.inviata_at);
  }

  notePendingCount(): number {
    return this.notePending ? 1 : 0;
  }

  onSaveNota() {
    const testo = (this.notaDraft || '').trim();
    if (!testo || !this.evento?.id) return;
    this.apiService.addNotaEvento({
      id_evento: this.evento.id,
      sezione: 'generale',
      testo,
      autore: 'Backoffice',
    }).subscribe({
      next: () => {
        this.loadNote();
        this.noteChanged.emit();
        this.apiService.message('success', 'Nota', 'Segnalazione salvata (non ancora inviata)');
      },
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || err?.error?.message || 'Errore'),
    });
  }

  onDeleteNota(id: number) {
    this.apiService.deleteNotaEvento(id).subscribe({
      next: () => {
        this.notaDraft = '';
        this.loadNote();
        this.noteChanged.emit();
      },
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Errore'),
    });
  }

  onInviaSegnalazioni() {
    const testo = (this.notaDraft || '').trim();
    if (!this.evento?.id || !testo) return;
    this.invioNoteLoading = true;
    // upsert bozza con il testo attuale, poi invia (niente “Aggiorna” obbligatorio)
    this.apiService.addNotaEvento({
      id_evento: this.evento.id,
      sezione: 'generale',
      testo,
      autore: 'Backoffice',
    }).subscribe({
      next: () => {
        this.apiService.inviaNoteEvento(this.evento!.id).subscribe({
          next: () => {
            this.invioNoteLoading = false;
            this.notaDraft = '';
            this.loadNote();
            this.noteChanged.emit();
            this.apiService.message('success', 'Invio', 'Segnalazione inviata alla compagnia');
          },
          error: (err) => {
            this.invioNoteLoading = false;
            this.loadNote();
            this.noteChanged.emit();
            this.apiService.message('error', 'Errore', err?.error?.message?.message || err?.error?.message || 'Errore invio');
          },
        });
      },
      error: (err) => {
        this.invioNoteLoading = false;
        this.apiService.message('error', 'Errore', err?.error?.message?.message || err?.error?.message || 'Errore salvataggio');
      },
    });
  }

  getData() {

    this.apiService.personaleEventoChanged.subscribe({
      next: (data) => this.evento!.personale = [...data || []],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    }) 

    this.apiService.subappaltiEventoChanged.subscribe({
      next: (data) => this.evento!.subappalti = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    }) 

    this.apiService.mezziTrasportoEventoChanged.subscribe({
      next: (data) => this.evento!.mezzi = [...data],
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    }) 

    this.apiService.documentiEventoChanged.subscribe({
      next: (data) => {
        this.evento!.documenti = [...data.filter(doc => !doc.id_personale)]
        this.syncPassFromDocumenti();
        this.documenti = [...this.evento?.documenti || []].filter(documento =>  !documento.id_personale && (documento.tipo != 'inps' && documento.tipo != 'scheda_tecnica' && documento.tipo != 'montaggio' && documento.tipo != 'pass_compagnia'));
        this.agibilita_inps = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'inps');
        this.schede_tecniche = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'scheda_tecnica');
        this.montaggio = [...this.evento?.documenti || []].filter(documento => documento.tipo == 'montaggio');
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    }) 

    this.sub.add(this.apiService.documentoStatoChanged.subscribe((idEvento) => {
      if (this.evento && Number(idEvento) === Number(this.evento.id)) {
        this.cdr.detectChanges();
      }
    }));

  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  onCertificazioni() {
    const data = this.evento?.certificazione_impianti ? this.evento.certificazione_impianti.split(',') : [];
    if (data.includes('non_presenti')) {
      this.certificazioni_impianti = false;
      this.certificazione_impianti = false;
    } else if (data.length > 0) {
      this.certificazioni_impianti = true;
      this.certificazione_impianti = true;
    } else {
      this.certificazioni_impianti = false;
      this.certificazione_impianti = false;
    }
    // BO: nessun file impianto obbligatorio
    this.formEvento.get('certificazione_impianti_extra')?.clearValidators();
    this.formEvento.get('certificazione_impianti_extra')?.updateValueAndValidity();
  }

  hasImpianto(value: string): boolean {
    return (this.formEvento.get('certificazione_impianti')?.value || []).includes(value);
  }

  docsByTipo(tipo: string): DocumentoAccredito[] {
    // API salva "altro" come certificazione_impianti_extra (allineato al FO)
    const key = tipo === 'altro' ? 'certificazione_impianti_extra' : tipo;
    return (this.documenti || []).filter(d =>
      d.tipo === key || (key === 'certificazione_impianti_extra' && d.tipo === 'altro')
    );
  }

  setImpianto(value: string, answer: string) {
    let current: string[] = [...(this.formEvento.get('certificazione_impianti')?.value || [])];
    const si = answer === 'Si';

    if (si) {
      if (value === 'non_presenti') {
        current = ['non_presenti'];
        this.certificazione_impianti = false;
        this.certificazioni_impianti = false;
      } else {
        current = current.filter(v => v !== 'non_presenti');
        if (!current.includes(value)) current.push(value);
        this.certificazione_impianti = true;
        this.certificazioni_impianti = true;
      }
    } else {
      current = current.filter(v => v !== value);
      if (value === 'non_presenti') this.certificazione_impianti = true;
    }

    // null solo se mai toccato; [] = risposto senza Si
    this.formEvento.patchValue({ certificazione_impianti: current });
    this.formEvento.get('certificazione_impianti')?.markAsDirty();
  }

  onCertificazioneImpianti(event: any) {
    if (event.checked.length > 0) {
      if (event.checked.includes('altro')) {
        this.certificazioni_impianti = true;
        this.certificazione_impianti = true;
        this.formEvento.get('certificazione_impianti_extra')?.setValidators(Validators.required);
      } else if (event.checked.includes('non_presenti')) {
        this.certificazioni_impianti = false;
        this.certificazione_impianti = false;
      } else {
        this.certificazioni_impianti = true;
        this.certificazione_impianti = true;
      }
    } else {
      this.certificazioni_impianti = false;
      this.certificazione_impianti = true;
    }

    if (event.checked.includes(event.originalEvent?.target?.defaultValue)) {
      if ((this.evento?.documenti || []).filter(doc => doc.tipo == event.originalEvent?.target?.defaultValue).length <= 0) {
        this.formEvento.get(event.originalEvent?.target?.defaultValue + '_file')?.setValidators(Validators.required)
      }
    } else {
      this.formEvento.get(event.originalEvent?.target?.defaultValue + '_file')?.removeValidators(Validators.required)
    }

    this.formEvento.get(event.originalEvent?.target?.defaultValue + '_file')?.updateValueAndValidity();
    this.formEvento.get('certificazione_impianti_extra_file')?.updateValueAndValidity();

  } 

  onPassCompagnia(pass: string) {
    if (pass == 'Si') {                        
      this.formEvento.get('pass_compagnia_file')?.setValidators(Validators.required);        
    } else {      
      this.formEvento.get('pass_compagnia_file')?.removeValidators(Validators.required);
    }        
  }

  onMerchandising(merchandising: RadioButtonClickEvent) {
    const ditta = this.formEvento.get('merchandising_ditta');
    const fatt = this.formEvento.get('merchandising_fatturazione');
    const email = this.formEvento.get('merchandising_email');
    if (merchandising.value == 'Si') {
      ditta?.setValidators(Validators.required);
      fatt?.clearValidators();
      email?.clearValidators();
      if (email?.value) email.setValidators(Validators.email);
    } else {
      ditta?.clearValidators();
      fatt?.clearValidators();
      email?.clearValidators();
      ditta?.setValue(null);
      fatt?.setValue(null);
      email?.setValue(null);
      this.formEvento.get('merchandising_visura')?.setValue(null);
    }
    ditta?.updateValueAndValidity();
    fatt?.updateValueAndValidity();
    email?.updateValueAndValidity();
  }

  onFirmacopie(firmacopie: RadioButtonClickEvent) {    
    if (firmacopie.value == 'Si') {                        
      this.formEvento.get('firmacopie_email')?.setValidators([Validators.required, Validators.email]);        
    } else {      
      this.formEvento.get('firmacopie_email')?.clearValidators();
    }
    this.formEvento.get('firmacopie_email')?.updateValueAndValidity();
  }

  get collectingArray(): FormArray {
    return this.formEvento.get('collecting') as FormArray;
  }

  private parseCollecting(raw: Evento['collecting']): CollectingDirittiAutore[] {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw as CollectingDirittiAutore[];
    try {
      const parsed = JSON.parse(String(raw));
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private collectingGroup(item?: CollectingDirittiAutore): FormGroup {
    return new FormGroup({
      nome: new FormControl(item?.nome || null, Validators.required),
      percentuale: new FormControl(item?.percentuale ?? null, [Validators.required, Validators.min(0), Validators.max(100)]),
    });
  }

  private setCollecting(items: CollectingDirittiAutore[]) {
    const arr = this.collectingArray;
    arr.clear();
    for (const item of items) arr.push(this.collectingGroup(item));
  }

  addCollecting() {
    this.collectingArray.push(this.collectingGroup());
  }

  removeCollecting(i: number) {
    this.collectingArray.removeAt(i);
  }

  onDeletePopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare l'evento?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteEvento(this.evento!.id).subscribe({
          next: (data) => this.apiService.setEventi(),
          error: (err) => this.apiService.message('error','Errore',err.error.message.message),
          complete: () => {            
            this.confirmationService.close();
            this.apiService.message('success','Eliminazione',"L'evento è stato eliminato con successo");
          },
        });
      },
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    let evento = new FormData();

    evento.append('evento', this.formEvento.get('evento')?.value || '');
    evento.append('dal', this.formEvento.get('dal_al')?.value ? this.datePipe.transform(this.formEvento.get('dal_al')?.value[0],'yyyy-MM-dd', ) || '' : '');
    evento.append('al', this.formEvento.get('dal_al')?.value ? this.datePipe.transform(this.formEvento.get('dal_al')?.value[1],'yyyy-MM-dd') || '' : '');
    evento.append('durata', this.formEvento.get('durata')?.value || 0);
    const tri = (v: unknown) => (v === 'Si' ? 'true' : v === 'No' ? 'false' : '');
    evento.append('intervallo', tri(this.formEvento.get('intervallo')?.value));
    evento.append('foto', tri(this.formEvento.get('foto')?.value));
    evento.append('merchandising', tri(this.formEvento.get('merchandising')?.value));
    evento.append('merchandising_ditta', this.formEvento.get('merchandising_ditta')?.value || '');
    evento.append('merchandising_visura', this.formEvento.get('merchandising_visura')?.value || '');
    evento.append('merchandising_fatturazione', this.formEvento.get('merchandising_fatturazione')?.value || '');
    evento.append('merchandising_email', this.formEvento.get('merchandising_email')?.value || '');
    evento.append('collecting', JSON.stringify(this.collectingArray.getRawValue() || []));
    evento.append('firmacopie', tri(this.formEvento.get('firmacopie')?.value));    
    evento.append('firmacopie_email', this.formEvento.get('firmacopie_email')?.value || '');
    const ov = !!this.formEvento.get('obbl_visura_compagnia')?.value;
    const op = !!this.formEvento.get('obbl_pos_compagnia')?.value;
    const osv = !!this.formEvento.get('obbl_visura_subappalti')?.value;
    const osp = !!this.formEvento.get('obbl_pos_subappalti')?.value;
    evento.append('obbl_visura_compagnia', ov ? '1' : '0');
    evento.append('obbl_pos_compagnia', op ? '1' : '0');
    evento.append('obbl_visura_subappalti', osv ? '1' : '0');
    evento.append('obbl_pos_subappalti', osp ? '1' : '0');
    // Legacy: qualunque obbligo attivo
    evento.append('obbligatorieta', (ov || op || osv || osp) ? 'true' : '');
    evento.append('blocco', this.formEvento.get('blocco')?.value || 72);        
    evento.append('ragione_sociale', this.formEvento.get('ragione_sociale')?.value || '');
    evento.append('piva', this.formEvento.get('piva')?.value || '');
    evento.append('sede', this.formEvento.get('sede')?.value || '');
    evento.append("anagrafica", this.formEvento.get('anagrafica')?.value);
    evento.append("email", this.formEvento.get('email')?.value);
    evento.append("telefono", this.formEvento.get('telefono')?.value);
    evento.append("visura_camerale", this.formEvento.get('visura_camerale')?.value || '');    
    evento.append("duvri_file", this.formEvento.get('duvri_file')?.value || '');        
    (this.formEvento.get('scheda_tecnica')?.value || []).map((file: File) => evento.append("scheda_tecnica", file || ''));    
    evento.append("pass", tri(this.formEvento.get('pass_compagnia')?.value));
    evento.append("pass_compagnia_file", this.formEvento.get('pass_compagnia_file')?.value || '');
    (this.formEvento.get('agibilita_inps_file')?.value || []).map((file: File) => evento.append("agibilita_inps_file", file || ''));    
    evento.append('attivita', this.formEvento.get('attivita')?.value ? this.formEvento.get('attivita')?.value.join(',') : '');    
    evento.append('montaggio', this.formEvento.get('montaggio')?.value ? (this.formEvento.get('montaggio')?.value.length > 0 ? "true" : "false") : "false");    
    (this.formEvento.get('montaggio_file')?.value || []).map((file: File) => evento.append("montaggio_file", file || ''));    
    evento.append("certificazione_impianti", this.formEvento.get('certificazione_impianti')?.value ? this.formEvento.get('certificazione_impianti')?.value.join(',') : '');    
    (this.formEvento.get('impianti_elettrici_file')?.value || []).map((file: File) => evento.append("impianti_elettrici_file", file || ''));
    (this.formEvento.get('impianti_luci_file')?.value || []).map((file: File) => evento.append("impianti_luci_file", file || ''));
    (this.formEvento.get('impianti_audio_file')?.value || []).map((file: File) => evento.append("impianti_audio_file", file || ''));
    (this.formEvento.get('impianti_video_file')?.value || []).map((file: File) => evento.append("impianti_video_file", file || ''));
    (this.formEvento.get('effetti_scenici_file')?.value || []).map((file: File) => evento.append("effetti_scenici_file", file || ''));
    (this.formEvento.get('macchina_fumo_file')?.value || []).map((file: File) => evento.append("macchina_fumo_file", file || ''));
    (this.formEvento.get('carichi_sospesi_file')?.value || []).map((file: File) => evento.append("carichi_sospesi_file", file || ''));    
    evento.append("certificazione_impianti_extra", this.formEvento.get('certificazione_impianti_extra')?.value || '');    
    (this.formEvento.get('certificazione_impianti_extra_file')?.value || []).map((file: File) => evento.append("certificazione_impianti_extra_file", file || ''));
    
    this.apiService.updateEvento(evento, this.evento!.id).subscribe({      
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {        
        if (this.spettacolo)
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => { this.router.navigate(['/backoffice/spettacoli/' + this.spettacolo!.id + '/area-compagnia']); });
        else
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => { this.router.navigate(['/backoffice/area-compagnie/' + this.evento!.id]); });

        this.apiService.message('success', 'Modifica', 'Evento modificato con successo!');        
      },
    });
  }

  get isVisuraScaduta(): boolean {
    const iso = this.normalizeYmd(this.evento?.visura_scadenza);
    if (!iso) return false;
    const d = this.parseYmdToDate(iso);
    if (!d) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    d.setHours(0, 0, 0, 0);
    return d.getTime() < today.getTime();
  }

  private normalizeYmd(value: string | Date | null | undefined): string | null {
    if (!value) return null;
    if (value instanceof Date) return this.toYmd(value);
    const s = String(value).trim();
    if (!s) return null;
    return s.length >= 10 ? s.slice(0, 10) : s;
  }

  private parseYmdToDate(value: string | Date | null | undefined): Date | null {
    const iso = this.normalizeYmd(value);
    if (!iso) return null;
    const d = new Date(`${iso}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  private toYmd(value: Date | null): string | null {
    if (!value || Number.isNaN(value.getTime())) return null;
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  onVisuraScadenza(value: Date | null) {
    if (!this.evento?.id) return;
    const iso = this.toYmd(value);
    const current = this.normalizeYmd(this.evento.visura_scadenza);
    // p-calendar può riemettere lo stesso giorno con un nuovo Date → evita loop HTTP/CD
    if (iso === current) {
      this.visuraScadenzaModel = value;
      return;
    }
    this.visuraScadenzaModel = value;
    this.apiService.updateVisuraScadenza(this.evento.id, iso).subscribe({
      next: () => {
        this.evento!.visura_scadenza = iso;
        this.apiService.message('success', 'Scadenza', iso ? 'Scadenza visura aggiornata' : 'Scadenza visura rimossa');
      },
      error: (err) => this.apiService.message('error', 'Errore', err?.error?.message?.message || 'Aggiornamento fallito'),
    });
  }

  archivioLoading = false;

  onArchivioFolder(event: Event) {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files || []);
    input.value = '';
    if (!files.length || !this.evento?.id) return;
    this.archivioLoading = true;
    this.apiService.addDocumentiArchivio(this.evento.id, files).subscribe({
      next: (res) => {
        this.apiService.setDocumentiEvento(this.evento!.id);
        this.apiService.message('success', 'Archivio', `${res?.count ?? files.length} file caricati`);
      },
      error: (err) => {
        this.archivioLoading = false;
        this.apiService.message('error', 'Errore', err?.error?.message?.message || err.message || 'Upload fallito');
      },
      complete: () => { this.archivioLoading = false; },
    });
  }

}
